// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--5-1!../../../node_modules/postcss-loader/src/index.js??ref--5-2!./fonts.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("2d04fb5c", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fonts.css
// module id = I6m9
// module chunks = 66